/**
 * Light haptic for DnD drag-start on touch (Vibration API).
 * iOS Safari: no public web haptic — documented no-op when vibrate is absent.
 */

export type SqDndHapticStrength = "light" | "medium" | "heavy";

const HAPTIC_DURATION_MS: Record<SqDndHapticStrength, number> = {
	light: 10,
	medium: 25,
	heavy: 40,
};

export function canUseSqDndHaptic(): boolean {
	return (
		typeof navigator !== "undefined" &&
		typeof navigator.vibrate === "function"
	);
}

/** Fire a short vibration. Never throws. Returns false when unsupported. */
export function triggerSqDndHaptic(
	strength: SqDndHapticStrength = "light",
): boolean {
	if (!canUseSqDndHaptic()) {
		return false;
	}
	try {
		return navigator.vibrate(HAPTIC_DURATION_MS[strength]);
	} catch {
		return false;
	}
}

/**
 * Haptic only when the primary pointer is coarse (touch).
 * Call from `DndContext` `onDragStart` so press-hold → drag feels armed.
 */
export function triggerSqDndDragStartHaptic(): boolean {
	if (typeof window === "undefined") {
		return false;
	}
	const coarse = window.matchMedia(
		"(hover: none) and (pointer: coarse)",
	).matches;
	if (!coarse) {
		return false;
	}
	return triggerSqDndHaptic("medium");
}
